import { t } from '@lingui/core/macro';
import { Packaging } from '@luminovo/api-contracts';
import { transEnum } from '@luminovo/frontend-utils';

import { packagingTranslations } from '../i18n';

export function formatPackaging(
    packaging: Packaging | null | undefined,
    opts?: {
        ifUnknown?: string;
    },
): string {
    const { ifUnknown = t`Unknown` } = opts ?? {};
    if (!packaging || !packagingTranslations[packaging]) {
        return ifUnknown;
    }
    return transEnum(packaging, packagingTranslations);
}
